import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import admin from './admin'
import assignor from './assignor'
import investor from './investor'
import provider from './provider'
import publicComponents from './public'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'admin.login' } },
    { path: '/admin', redirect: { name: 'admin.assignor.dashboard' } },
    { path: '/investidor', redirect: { name: 'investor.emissions' } },
    {
      path: '/nao-autorizado',
      name: 'misc-not-authorized',
      component: () => import('@/views/common/pages/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        action: 'read',
        resource: 'Auth',
      },
    },
    ...admin,
    ...assignor,
    ...investor,
    ...provider,
    ...publicComponents,
    { path: '/admin/*', redirect: { name: 'admin.assignor.dashboard' } },
    { path: '/investidor/*', redirect: { name: 'investor.emissions' } },
    { path: '/cedente/*', redirect: { name: 'assignor.emissions' } },
    { path: '/prestadordeservico/*', redirect: { name: 'provider.emissions' } },
    { path: '/admin*', redirect: { name: 'admin.assignor.dashboard' } },
    { path: '/investidor*', redirect: { name: 'investor.emissions' } },
    { path: '/cedente*', redirect: { name: 'assignor.emissions' } },
    { path: '/prestadordeservico*', redirect: { name: 'provider.emissions' } },
    { path: '/*', redirect: { name: 'investor.emissions' } },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  const userData = getUserData()

  const correctLoginRoute = {
    admin: 'admin.login',
    investor: 'investor.login',
    assignor: 'assignor.login',
    provider: 'provider.login',
  }

  const userType = {
    'Admin::User': 'admin',
    'Investidor::User': 'investor',
    'Cedente::User': 'assignor',
    'Fornecedor::User': 'provider',
  }

  const userDiffRouter =
  userType[userData?.type] != to.name.split('.')[0] && to.name != 'misc-not-authorized'

  const canAccessPortalInvestor = userData?.portal_investidor
 
  // Verifica se esta na tela de login e se o usuario esta logado
  // se esta logado verifica se não esta na tela do pŕoprio tipo de usuario
  // se estiver, segue o fluxo normal
  // se não estiver, permite que fique na tela de login e se autentique como outro tipo
  if (
    Object.values(correctLoginRoute).includes(to.name) 
    && !to.name.includes(userType[userData?.type])
  ) return next();
  
  if (canNavigate(to)) {
    // Redirect to log in if not logged in
    if (!isLoggedIn) return next({ name: 'admin.login' })
    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) next(getHomeRouteForLoggedInUser(userData?.type))

  if (!canNavigate(to) && !isLoggedIn && !to.meta.redirectIfLoggedIn) {
    return next({ name: correctLoginRoute[to.name.split('.')[0]] })
  }

  if (
    isLoggedIn &&
    !['misc-not-authorized', 'emissoes', 'detalhes', 'precosUnitarios'].includes(to.name) &&
    (userDiffRouter && !canAccessPortalInvestor)  &&
    !to.meta.redirectIfLoggedIn
  ) {
    return next({ name: 'misc-not-authorized' })
  }

  return next()
})

export default router
